import axios from 'axios'
import { BASE_URL } from '../../constants/config'


async function getUserCoupon(token, userCouponId) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/userCoupon/${userCouponId}`
    }
    return axios(options)
}

async function redeemUserCoupon(token, userCouponId) {
    const options = {
        method: 'post',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/userCoupon/${userCouponId}/redeem`
    }
    return axios(options)
}
export default {
    getUserCoupon,
    redeemUserCoupon
}